export default __webpack_public_path__ + "static/media/TB_Go_Chat.a8cb957e.svg";